import * as React from 'react';
import SvgIcon from '../../SvgIcon';
const SvgWarning = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M11 3.87.86 19.27s-2 1.66.11 1.71h22.26s1.75.16 0-1.71L12.94 3.91S12 1.93 11 3.87m1 2a1.49 1.49 0 0 1 1.49 1.48v6.47a1.52 1.52 0 0 1-1.63 1.41A1.33 1.33 0 0 1 10.47 14a.4.4 0 0 1 0-.16V7.4a1.58 1.58 0 0 1 1.58-1.54Zm0 10.56A1.56 1.56 0 1 1 10.48 18 1.55 1.55 0 0 1 12 16.42Z"
    }));
export default SvgWarning;
